/* =============================================================================
 * M.M.LaFleur — "Shop this look" drawer: size selects and add-all wiring.
 *
 * Loaded from sections/mm_footer.liquid.
 *
 * mm-editorial.js already owns the Add to bag click — it reads the variant id
 * straight off `data-mm-look-add` — so rather than duplicate cart logic, this
 * script only ever WRITES that attribute. Choosing a size fills it in and
 * enables the button; everything after that is the existing handler's job.
 *
 * The same trick covers Add all: `data-mm-look-add-all` is a comma-separated
 * list read by the same file, recomputed here from whatever each row has
 * currently selected.
 * ========================================================================== */

(function () {
  "use strict";

  /* Platter re-injects the footer's scripts around a Barba container swap. */
  if (window.__mmLookSizeBound) return;
  window.__mmLookSizeBound = true;

  function items() {
    return Array.prototype.slice.call(document.querySelectorAll("[data-mm-look-item]"));
  }

  /* Add all only offers what is actually addable. A row still waiting on a
     size contributes nothing rather than defaulting to a guess — the whole
     point of the select is that nobody ends up with 00 by accident. */
  function refreshAddAll() {
    var all = document.querySelector("[data-mm-look-add-all]");
    if (!all) return;

    var ids = [];
    var waiting = 0;

    items().forEach(function (row) {
      var btn = row.querySelector("[data-mm-look-add]");
      if (!btn) return;
      var id = btn.getAttribute("data-mm-look-add");
      if (id) {
        ids.push(id);
      } else if (row.querySelector("[data-mm-look-select]")) {
        waiting += 1;
      }
    });

    all.setAttribute("data-mm-look-add-all", ids.join(","));
    all.disabled = ids.length === 0;

    /* Say why the button is doing less than its label implies, rather than
       letting it silently add a subset. */
    var note = document.querySelector("[data-mm-look-note]");
    if (note) {
      if (waiting > 0) {
        note.textContent = waiting === 1
          ? "Choose a size for 1 more piece to add everything."
          : "Choose a size for " + waiting + " more pieces to add everything.";
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }
  }

  document.addEventListener("change", function (event) {
    var select = event.target;
    if (!select.matches || !select.matches("[data-mm-look-select]")) return;

    var row = select.closest("[data-mm-look-item]");
    if (!row) return;

    var btn = row.querySelector("[data-mm-look-add]");
    if (btn) {
      btn.setAttribute("data-mm-look-add", select.value || "");
      btn.disabled = !select.value;
    }

    refreshAddAll();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshAddAll);
  } else {
    refreshAddAll();
  }

  document.addEventListener("shopify:section:load", refreshAddAll);
}());
